import type { CurrencyInputProps } from '../currency-input';

import { Controller, useFormContext } from 'react-hook-form';

import { CurrencyInput } from '../currency-input';

// ----------------------------------------------------------------------

export type RHFCurrencyFieldProps = Omit<CurrencyInputProps, 'value' | 'onChange'> & {
  name: string;
};

/**
 * RHF-bound currency input. Stores a raw `number | null` and renders the value
 * with thousands/decimal separators matching the org/user country (via the
 * `currency` prop → locale).
 */
export function RHFCurrencyField({ name, currency, locale, helperText, ...other }: RHFCurrencyFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <CurrencyInput
          {...other}
          currency={currency}
          locale={locale}
          value={field.value ?? null}
          onChange={(value) => field.onChange(value)}
          onBlur={field.onBlur}
          error={!!error}
          helperText={error?.message ?? helperText}
        />
      )}
    />
  );
}
